module.exports = __webpack_public_path__ + "img/video.6fdcd150.png";